import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Servicios.module.css';

export const ServiceCard = ({ service, index = 0 }) => {
  const reverse = index % 2 !== 0;
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.12 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`${styles.franja} ${reverse ? styles.franjaReverse : ''} ${visible ? styles.franjaVisible : ''}`}
    >
      <div className={styles.franjaImagen}>
        <img src={service.image} alt={service.name} className={styles.franjaImg} loading="lazy" />
        <div className={styles.franjaOverlay} />
      </div>

      <div className={styles.franjaTexto}>
        <span className={styles.franjaNumero}>{String(index + 1).padStart(2, '0')}</span>
        <h3 className={styles.franjaTitulo}>{service.name}</h3>
        <div className={styles.franjaLinea} />
        <p className={styles.franjaDesc}>{service.shortDescription}</p>
        <ul className={styles.franjaSpecs}>
          {service.specs.slice(0, 2).map((spec, i) => (
            <li key={i} className={styles.franjaSpecItem}>
              <span className={styles.franjaBullet} />
              {spec}
            </li>
          ))}
        </ul>
        <Link to={`/servicios/${service.slug}`} className={styles.franjaBtn}>
          Ver Detalles
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            strokeWidth={2} stroke="currentColor" width="16" height="16">
            <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
          </svg>
        </Link>
      </div>
    </div>
  );
};
export default ServiceCard;
